export const FETCH_RESULTS_PENDING = "FETCH_RESULTS_PENDING";
export const FETCH_RESULTS_SUCCESS = "FETCH_RESULTS_SUCCESS";
export const FETCH_RESULTS_ERROR = "FETCH_RESULTS_ERROR";

const initialState = {
  pending: false,
  results: [],
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_RESULTS_PENDING:
      return {
        ...state,
        pending: true,
        error: null
      };
    case FETCH_RESULTS_SUCCESS:
      return {
        ...state,
        pending: false,
        results: action.results,
        error: null
      };
    case FETCH_RESULTS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
}

//Show a loading gif
export function fetchResultsPending() {
  return {
    type: FETCH_RESULTS_PENDING,
    results: [],
    error: null,
    pending: true
  };
}

//Show data
export function fetchResultsSuccess(results) {
  return {
    type: FETCH_RESULTS_SUCCESS,
    results: results,
    error: null,
    pending: false
  };
}

//Show error: ups sorry or something
export function fetchResultsError(error) {
  return {
    type: FETCH_RESULTS_ERROR,
    results: [],
    error: error,
    pending: false
  };
}

export const getResults = state => state.results;
export const getResultsPending = state => state.pending;
export const getResultsError = state => state.error;
